import { render } from "./NavbarMain.vue?vue&type=template&id=071d1a3e"
import script from "./NavbarMain.vue?vue&type=script&lang=js"
export * from "./NavbarMain.vue?vue&type=script&lang=js"

import "./NavbarMain.vue?vue&type=style&index=0&id=071d1a3e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__